<template>
  <div :class="className" :style="{height:height,width:width,margin:margin}"/>
</template>

<script>
import resize from '@/mixin/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '260px'
    },
    margin: {
      type: String,
      default: '0'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions(chartData) {
      let seriesData = []
      for (let key in chartData.v_92740015) {
        seriesData.push({
          name: key,
          value: chartData.v_92740015[key].replace('%', '')
        })
      }
      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '<div class="flex acenter">\n' +
              '      <div style="width: 8px;height: 8px;background: #3371C5;border-radius: 50%"></div>\n' +
              '      <span class="font-14 color-9 ml10 mr10">{b}</span>\n' +
              '      <span class="font-14 color-9">{c}%</span>\n' +
              '    </div>'
        },
        legend: {
          type: 'scroll',
          top: 'middle',
          left: 420,
          orient: 'vertical',
          width: '10px',
          textStyle: {
            width: 100,
            overflow: 'breakAll'
          }
        },
        series: [
          {
            name: '部门薪资比例',
            type: 'pie',
            selectedMode: 'single',
            width: 300,
            height: 240,
            top: 'middle',
            left: 80,
            radius: ['0%', '80%'],
            itemStyle: {
              borderColor: '#FFFFFF',
              borderWidth: 1
            },
            label: {
              width: 100,
              formatter: '{b}\n{d}%'
            },
            emphasis: {},
            labelLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            },
            data: seriesData
          }
        ]
      })
    }
  }
}
</script>
